// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__3dcC3","filesListContainer":"PosDisputesFiles_filesListContainer__1pPxP","filesButton":"PosDisputesFiles_filesButton__4v-vs"};